export default class ProcessingEnterprise
{
	constructor(
        id,
        name,
        lastCall,
		grainPrice,
		expirationContractDate,
		willExpireSoon
    ) {
        this.id = id;
        this.name = name;
        this.lastCall = lastCall;
        this.grainPrice = grainPrice;
        this.expirationContractDate = expirationContractDate;
        this.willExpireSoon = willExpireSoon;
	}
}



// WEBPACK FOOTER //
// ./apiClient/ReadModels/ProcessingEnterprise.js